module.exports = __webpack_public_path__ + "img/blog4.34115a27.jpg";